import {
    StyleSheet
} from "react-native";
import {
    webStyle
} from "ncore-ui-kit";

const stylesheet = StyleSheet.create({
    headerContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    loadingContainer: {
        justifyContent: "center",
        alignItems: "center",
        minHeight: 200
    },
    diffRow: {
        alignItems: "flex-start",
        flexDirection: "row"
    },
    badgeContainer: {
        alignItems: "flex-start"
    },
    requestedValueWrapper: {
        flexDirection: "column"
    },
    diffTableContainer: {
        flexDirection: "column"
    },
    requestedValueContainer: {
        flex: 1
    },
    closeButton: {
        ...webStyle({
            cursor: "pointer"
        })
    },
    footerActionsContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    footerContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    photoDiffContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    tableHeaderRow: {
        flexDirection: "row",
        alignItems: "center"
    },
    currentValueContainer: {
        flex: 1
    },
    errorContainer: {
        alignItems: "center"
    },
    fieldLabelContainer: {
        width: 150
    },
    profilePhotoPreview: {
        height: 56,
        width: 56
    },
    container: {
        maxWidth: "94%",
        width: 720
    },
    contentContainer: {
        maxHeight: 520
    }
});
export default stylesheet;
